import { Box } from "@mui/material";
import { useState } from "react";
import { CheckIcon, CloseIcon } from "./icons";
import { useStyles } from "./style";
import { Details, Billing, Requests } from "./elements";
import { Button } from "..";
import { useTranslation } from "react-i18next";
import { User } from "../../types";
import { useUpdateUser } from "../../service/api";

interface AccountDetailsProps {
  onClose?: () => void;
  account: User | null;
}

export const AccountDetails = ({ onClose, account }: AccountDetailsProps) => {
  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useState("details");

  const classes = useStyles();

  const { mutate: updateUser } = useUpdateUser();

  const initialDetailsFormData = {
    apaSerial: account?.apaSerial || "",
    email: account?.email || "",
    name: account?.name || "",
    phone: account?.phone || "",
  };

  const initialBillingFormData = {
    // address: account?.address || "",
    // paymentMethod: account?.paymentMethod || "",
    // subscriptionStatus: account?.subscriptionStatus || "",
  };

  const initialRequestsFormData = {
    // requestType: account?.requestType || "",
    // requestStatus: account?.requestStatus || "",
  };

  const [detailsFormData, setDetailsFormData] = useState(
    initialDetailsFormData
  );
  const [billingFormData, /*setBillingFormData*/] = useState(
    initialBillingFormData
  );
  const [requestsFormData, /*setRequestsFormData*/] = useState(
    initialRequestsFormData
  );

  const handleDetailsChange = (field: string, value: string) => {
    setDetailsFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // const handleBillingChange = (field: string, value: string) => {
  //   setBillingFormData((prev) => ({
  //     ...prev,
  //     [field]: value,
  //   }));
  // };

  // const handleRequestsChange = (field: string, value: string) => {
  //   setRequestsFormData((prev) => ({
  //     ...prev,
  //     [field]: value,
  //   }));
  // };

  const submitDetailsForm = () => {
    if (account?.id) {
      updateUser({ data: detailsFormData, userId: account.id });
    }
  };

  const submitBillingForm = () => {
    console.log("Billing Form Submitted", billingFormData);
    // Handle API call or any logic for submitting Billing form
  };

  const submitRequestsForm = () => {
    console.log("Requests Form Submitted", requestsFormData);
    // Handle API call or any logic for submitting Requests form
  };

  // check if there are any changes in the form data
  const hasChanges = (initialData: any, currentData: any) => {
    return JSON.stringify(initialData) !== JSON.stringify(currentData);
  };

  // Determine if the "OK" button should be enabled or disabled based on changes
  const isDetailsFormChanged = hasChanges(
    initialDetailsFormData,
    detailsFormData
  );
  const isBillingFormChanged = hasChanges(
    initialBillingFormData,
    billingFormData
  );
  const isRequestsFormChanged = hasChanges(
    initialRequestsFormData,
    requestsFormData
  );

  const isOkButtonDisabled =
    (activeTab === "details" && !isDetailsFormChanged) ||
    (activeTab === "billing" && !isBillingFormChanged) ||
    (activeTab === "requests" && !isRequestsFormChanged);

  return (
    <Box
      className={
        activeTab === "requests" ? classes.requestsContainer : classes.container
      }
    >
      {/* Header */}
      <Box className={classes.headerWrapper}>
        <Box className={classes.title}>{t("accountDetails.title")}</Box>
        <Box className={classes.closeIconWrapper} onClick={onClose}>
          <CloseIcon width={24} height={24} />
        </Box>
      </Box>

      {/* Tabs */}
      <Box className={classes.bodyContainer}>
        <Box className={classes.tabsContainer}>
          <Box
            className={
              activeTab === "details" ? classes.activeTab : classes.tab
            }
            onClick={() => setActiveTab("details")}
          >
            {t("accountDetails.details")}
          </Box>
          <Box
            className={
              activeTab === "billing" ? classes.activeTab : classes.tab
            }
            onClick={() => setActiveTab("billing")}
          >
            {t("accountDetails.billing")}
          </Box>
          <Box
            className={
              activeTab === "requests" ? classes.activeTab : classes.tab
            }
            onClick={() => setActiveTab("requests")}
          >
            {t("accountDetails.requests")}
          </Box>
        </Box>

        {/* Tab Content */}
        <Box className={classes.innerBodyContainer}>
          {activeTab === "details" && (
            <Details
              account={account}
              formData={detailsFormData}
              handleChange={handleDetailsChange}
            />
          )}
          {activeTab === "billing" && <Billing />}
          {activeTab === "requests" && <Requests />}
        </Box>
      </Box>
      {/* Bottom Buttons Container */}
      <Box className={classes.buttonsWrapper}>
        <Button className={classes.btn} color="text" onClick={onClose}>
          {t("accountDetails.cancel")}
        </Button>

        <Button
          className={classes.btn}
          color="primary"
          icon={<CheckIcon width={17} height={16} />}
          onClick={
            activeTab === "details"
              ? submitDetailsForm
              : activeTab === "billing"
              ? submitBillingForm
              : submitRequestsForm
          }
          disabled={isOkButtonDisabled}
        >
          {t("accountDetails.ok")}
        </Button>
      </Box>
    </Box>
  );
};
